/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import { createStore } from 'vuex';
// Global
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Module
import createPersistedState from 'vuex-persistedstate';

const modules = {}
const vuexModules = require.context(
  './modules',
  true,
  /[A-Za-z0-9-_,\s]+\.(js)$/i
)

function mapModules (context) {
  const keys = context.keys()
  const values = keys.map(context)

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)

    if (matched && matched.length > 1) {
      const moduleName = matched[1]
      const module = values[i].default

      if (module) {
        modules[moduleName] = values[i].default
      }
    }
  }
}

mapModules(vuexModules)


// Init instance of store
export default createStore({
  getters,
  mutations,
  state,
  actions,
  modules: modules,
  strict: false,
  plugins: [
    createPersistedState({
      key: 'eoffice_vuex',
      paths: ['context', 'export'],
      getState: key => {
        let temp = localStorage.getItem(key);
        if (temp && typeof temp === 'string') {
          let state = JSON.parse(temp);
          if (state) {
            let context = state.context;
            if (context && context.Token) {
              context.Context = context.Context || {};

              try {
                context.TokenExpired = new Date(context.TokenExpired);

                if (context.PostedDate) {
                  context.PostedDate = new Date(context.PostedDate);
                } else {
                  let now = new Date();
                  context.PostedDate = new Date(
                    now.getFullYear(),
                    now.getMonth(),
                    now.getDate()
                  );
                }
              } catch (ex) {
                console.error(ex);
              }
            }
          }

          return state;
        }
        return null;
      },
      setState: (key, state) => {
        localStorage.setItem(key, JSON.stringify(state));
      }
    })
  ]
});
